export const normalizeUpperCase = text => text.replace(/([A-Z])/g, ' $1').trim();
